import { ROUTE } from "../../routes";
import { api } from "../../configs/api";
import { CreditApplicationType, getAppHeader } from "../../configs/config";
import { getApplicationId, getFaqData, MfCentralFlow, nextStepCredStepper, nextStepId, showHelpAndSupportField } from "../../configs/utils";
import AsyncStorage from "@react-native-async-storage/async-storage";
import SharedPropsService from "../../SharedPropsService";
export const viewDetailsAction = async (action, _datastore, { navigate, network, setDatastore }) => {
    await setDatastore(ROUTE.MANAGE_LIMIT_LANDING, "manageLimitLanding", {
        showNavNextLoader: true
    });
    const requestOptions = {
        method: 'GET',
        headers: await getAppHeader(),
    };
    const user = await SharedPropsService.getUser();
    const creditResponse = await network
        .get(`${api.getCollateral}${user.linkedCredits[0].creditId}`, requestOptions);
    const tempData = creditResponse.data;
    await setDatastore(ROUTE.MANAGE_LIMIT_LANDING, "manageLimitLanding", {
        showNavNextLoader: false
    });
    await SharedPropsService.setPortfolioData(creditResponse.data);
    await navigate(ROUTE.VIEW_PORTFOLIO_DETAIL, { tempData: tempData });
};
export const faqsAction = async (action, _datastore, { navigate, goBack }) => {
    const showHelpAndSupport = await showHelpAndSupportField();
    const faqData = await getFaqData();
    let data;
    let title;
    faqData.forEach(item => {
        if (item.id === 'COLLATERAL') {
            data = item?.cards;
            title = item?.title;
        }
    });
    if (showHelpAndSupport) {
        await navigate(ROUTE.FAQ_SCREEN, { data, title });
    }
    else
        await navigate(ROUTE.FAQ);
};
export const goBackAction = async (action, _datastore, { navigate, goBack }) => {
    await navigate(ROUTE.MANAGE_LIMIT);
};
export const needHelpAction = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const fetchMyPortfolio = async (action, _datastore, { network, navigate, setDatastore, goBack, analytics, instrumentTrack, ...props }) => {
    await setDatastore(ROUTE.MANAGE_LIMIT_LANDING, "manageLimitLanding", {
        loading: true
    });
    let applicationId = '';
    if (await AsyncStorage.getItem("application_id") === null) {
        const user = await SharedPropsService.getUser();
        const creditId = user.linkedCredits[0].creditId;
        const response = await network.post(`${api.getLimitModificationApplicationForAccountV2}${creditId}/v2`, {
            creditApplicationType: CreditApplicationType.CREDIT_MODIFICATION_AGAINST_SECURITIES,
        }, {
            headers: await getAppHeader(),
        });
        applicationId = response.data.applicationId;
        await AsyncStorage.setItem("application_id", applicationId);
    }
    else {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    const updatedApplicationResponse = await network.get(`${api.borrowerApplication}${applicationId}`, { headers: await getAppHeader() });
    const currentStepId = updatedApplicationResponse.data.currentStepId;
    const routeObj = await nextStepCredStepper(currentStepId);
    await navigate(routeObj.routeId, routeObj.params);
    await setDatastore(ROUTE.MANAGE_LIMIT_LANDING, "manageLimitLanding", {
        loading: false
    });
};
export const continueEditAction = async (action, _datastore, { network, navigateWithClear, setDatastore }) => {
    await setDatastore(ROUTE.MANAGE_LIMIT_LANDING, "manageLimitLanding", {
        editLimitLoader: true
    });
    const userData = await SharedPropsService.getUser();
    let applicationId = '';
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = userData.linkedApplications[0].applicationId;
    }
    const enabledRTAFlowResponse = await network.get(`${api.isFromMFCentralFlow}${applicationId}`, { headers: await getAppHeader() });
    const continueEditResponse = await network.get(`${api.editLimitRoute}${applicationId}`, {
        headers: await getAppHeader()
    });
    const isFromMFCentral = enabledRTAFlowResponse?.data?.enabledRtaFlow === MfCentralFlow;
    if (isFromMFCentral) {
        await navigateWithClear(ROUTE.MFC_FETCH_ANCHOR);
    }
    else {
        const currentStepId = continueEditResponse.data.updatedApplicationObj.currentStepId;
        const routeObj = await nextStepCredStepper(currentStepId);
        await navigateWithClear(routeObj.routeId, routeObj.params);
    }
};
export const continueApplicationAction = async (action, _datastore, { network, navigateWithClear, setDatastore }) => {
    await navigateWithClear(ROUTE.KYC_STEPPER);
};
export const continueApplication = async (action, _datastore, { network, navigateWithClear, setDatastore }) => {
    await setDatastore(ROUTE.MANAGE_LIMIT_LANDING, "manageLimitLanding", {
        unlockLimitLoader: true
    });
    const applicationId = await getApplicationId();
    const continueEditResponse = await network.get(`${api.borrowerApplication}${applicationId}`, {
        headers: await getAppHeader()
    });
    const currentStepId = continueEditResponse?.data?.currentStepId;
    if (currentStepId === "MF_FETCH_PORTFOLIO" || currentStepId === "MF_PLEDGE_PORTFOLIO") {
        const enabledRTAFlowResponse = await network.get(`${api.isFromMFCentralFlow}${applicationId}`, { headers: await getAppHeader() });
        const isFromMFCentral = enabledRTAFlowResponse?.data?.enabledRtaFlow === MfCentralFlow;
        const mfcFetchStatus = enabledRTAFlowResponse?.data?.mfcFetchStatus;
        if (mfcFetchStatus === "IN_PROGRESS") {
            await navigateWithClear(ROUTE.MFC_FETCH_EVALUTE_FUNDS);
        }
        else if (isFromMFCentral && currentStepId === ROUTE.MF_PLEDGE_PORTFOLIO) {
            await navigateWithClear(ROUTE.MFC_FETCH_ANCHOR);
        }
        else if (isFromMFCentral && currentStepId === ROUTE.MF_FETCH_PORTFOLIO) {
            await navigateWithClear(ROUTE.MF_FETCH_PORTFOLIO);
        }
        else if (!isFromMFCentral) {
            const routeObj = await nextStepId(currentStepId);
            await navigateWithClear(routeObj.routeId, routeObj.params);
        }
    }
    else {
        const currentStepId = continueEditResponse.data.currentStepId;
        const routeObj = await nextStepCredStepper(currentStepId);
        await navigateWithClear(routeObj.routeId, routeObj.params);
    }
    await setDatastore(ROUTE.MANAGE_LIMIT_LANDING, "manageLimitLanding", {
        unlockLimitLoader: false
    });
};
